// Auth storage helper with optional "Remember me" behaviour.
// - Default (remember=false): token in sessionStorage (cleared on tab close — safer)
// - remember=true: token in localStorage (persists across tabs/restarts)
// getToken() reads from both, preferring sessionStorage (current tab).
const TOKEN_KEY = "bb_admin_token";
const EMAIL_KEY = "bb_admin_email";
const REMEMBER_KEY = "bb_admin_remember";

export const getToken = () =>
  sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);

export const setSession = (token, email, remember = false) => {
  // Clear both first to avoid stale entries
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
  if (remember) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(REMEMBER_KEY, "1");
  } else {
    sessionStorage.setItem(TOKEN_KEY, token);
    localStorage.removeItem(REMEMBER_KEY);
  }
  if (email) localStorage.setItem(EMAIL_KEY, email);
};

export const getEmail = () => localStorage.getItem(EMAIL_KEY);

export const isRemembered = () => localStorage.getItem(REMEMBER_KEY) === "1";

export const clearSession = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
  localStorage.removeItem(REMEMBER_KEY);
};
